import React from "react";
import { AlignedBoxSubTitle, AlignedBoxTitle } from "../../../../styles/texts";
import { GrayButton } from "../../../../styles/buttons";
import { useNavigate } from "react-router-dom";
import GrayCard from "../GreyRectangles/GreyCard";

const PreInstallationCard: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <GrayCard>
      <div className="text-left flex flex-col w-full h-full self-stretch justify-center p-4">
        {/* Título y subtítulo */}
        <div style={{ textAlign: "left" }}>  
          <AlignedBoxSubTitle fontSize="14px">Etapa actual</AlignedBoxSubTitle>
          <AlignedBoxTitle fontSize="18px">Visita pre-instalación</AlignedBoxTitle>
          <AlignedBoxSubTitle fontSize="14px">
            14 de septiembre
          </AlignedBoxSubTitle>
        </div>

        {/* Descripción */}
        <div className="mt-4 text-gray-600 text-sm leading-5">
          Estamos a la espera de la visita pre-instalación. En esta visita, el
          equipo técnico revisa los techos, el tablero general de la casa, el
          lugar donde se ubicará el inversor, la ruta de canalización, etc.
          Recomendamos que te encuentres en tu casa para que revises y estés de
          acuerdo con los detalles del sistema.
        </div>

        {/* Botón */}
        <div className="mt-6 w-full text-left flex flex-col items-end">
          <GrayButton
            label="Ver próximos pasos"
            icon="rightarrow"
            w="250px"
            onClick={() => navigate("/steps")}
          />
        </div>
      </div>
    </GrayCard>
  );
};

export default PreInstallationCard;


/* 
<GrayBorderBox w="100%" h="auto" p="24px" m="16px">
      {/ Título y subtítulo /}
      <div style={{ textAlign: "left" }}>  
        <AlignedBoxSubTitle fontSize="14px">Etapa actual</AlignedBoxSubTitle>
        <AlignedBoxTitle fontSize="18px">Vista pre-instalación</AlignedBoxTitle>
        <AlignedBoxSubTitle fontSize="14px">
          14 de septiembre
        </AlignedBoxSubTitle>
      </div>

      {/ Descripción /}
      <div className="mt-4 text-gray-600 text-sm leading-5">
        Estamos a la espera de la visita pre-instalación. En esta visita, el
        equipo técnico revisa los techos, el tablero general de la casa, el
        lugar donde se ubicará el inversor, la ruta de canalización, etc.
        Recomendamos que te encuentres en tu casa para que revises y estés de
        acuerdo con los detalles del sistema.
      </div>

      {/ Botón /}
      <div style={{ marginTop: "24px", textAlign: "left" }}>
        <GrayButton
          label="Ver próximos pasos"
          icon="rightarrow"
          w="250px"
          onClick={() => navigate("/steps")}
        />
      </div>
    </GrayBorderBox>
*/
